import { ViewModel, View } from "binder"
import { ProducerEditorView } from "./producerEditor-view"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { IProducer } from "../IProducer";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";

export class ProducerEditorViewModel extends ViewModel implements IProducer, IPopup {
    constructor(parentViewModel: ViewModel, updater: IServerUpdater) {
        super(parentViewModel);
        this._serverUpdater = updater;
    }
    GetDefaultView(): View<ViewModel> {
        return new ProducerEditorView();
    }
    public getTypeId(): string {
        return "VM-9B102BE0-4600-472C-A3D8-CED9B6DC4269"
    }

    private _serverUpdater: IServerUpdater;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;
    public set country(v: string) { this._country = v; } public get country(): string { return this._country; } private _country: string;

    closePopup(result?: any) {

    }

    async cloneTo(producer: IProducer) {
        producer.id = this.id;
        producer.name = this.name;
        producer.code = this.code;
        producer.country = this.country;
    }

    back() {
        this.closePopup(null);
    }

    async save(): Promise<void> {
        let verificationResult = this.verify();
        if (verificationResult.length > 0) {
            this.messageBoxConfirmWarning(verificationResult.join('\n'), 'خطا در ثبت سازنده');
            return;
        } else {
            try {
                this.isLoading = true;
                let result = await this._serverUpdater.execute(this);
                if (result.IsSuccessful == false) {
                    if (result.Faults[0].Parameters.FaultId == '0444EA07-B96F-44B0-9432-47851CEB6078') {
                        await this.messageBoxConfirmWarning('اطلاعات به اشتباه وارد شده است.', 'خطا در عملیات');
                    }
                    else if (result.Faults[0].Parameters.FaultId == '096473E7-67AE-4206-9B61-79B70943684A') {
                        await this.messageBoxConfirmWarning('امکان ثبت کد سازنده تکراری وجود ندارد.', 'خطا در عملیات');
                    }
                }
                else {
                    await this.messageBoxConfirmSuccess('سازنده با موفقیت ثبت شد.', 'ثبت موفق');
                    this.closePopup('done');
                }
            } catch (ex) {
                await this.messageBoxConfirmWarning('خطا در ثبت سازنده', 'خطا در عملیات');
                console.log(ex);
            } finally {
                this.isLoading = false;
            }
        }
    }

    verify(): string[] {
        let result: string[] = [];
        if (stringIsNullOrEmpty(this.name)) {
            result.push('نام سازنده مشخص نشده است.');
        }
        if (stringIsNullOrEmpty(this.code)) {
            result.push('کد سازنده مشخص نشده است.');
        }
        return result;
    }
}

export interface IServerUpdater {
    execute(producer: IProducer): Promise<any>;
}

export class ProducerInserter implements IServerUpdater {
    async execute(producer: IProducer): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/ProducerServices/CreateProducer', {
                Name: producer.name,
                Code: producer.code,
                Country: producer.country
            });
            return result;
        } catch (ex) {
            throw ex;
        }
    }
}

export class ProducerUpdater implements IServerUpdater {
    async execute(producer: IProducer): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/ProducerServices/UpdateProducer', {
                ProducerId: producer.id,
                Name: producer.name,
                Code: producer.code,
                Country: producer.country
            });
            return result;
        } catch (ex) {
            throw ex;
        }
    }
}
